interface TechnicalDocumentProgressProps {
  status: string;
  error?: string | null;
}

export default function TechnicalDocumentProgress({
  status,
  error,
}: TechnicalDocumentProgressProps) {
  const normalized = status.toLowerCase();
  const isFailed = normalized === 'failed';

  if (isFailed) {
    return (
      <div className="mt-3 px-3 py-2 flex items-center gap-2">
        <div className="w-2 h-2 rounded-full bg-destructive flex-shrink-0" />
        <span className="text-destructive" style={{ fontSize: 'var(--text-caption)' }}>
          Erro na extracção
          {error && ` — ${error.substring(0, 80)}`}
        </span>
      </div>
    );
  }

  // All non-failed, non-done states show a simple pulse animation
  return (
    <div className="mt-3 px-3 py-2 flex items-center gap-3">
      <div className="flex gap-1 flex-shrink-0">
        <div className="w-2 h-2 rounded-full bg-primary animate-bounce" style={{ animationDelay: '0ms' }} />
        <div className="w-2 h-2 rounded-full bg-primary animate-bounce" style={{ animationDelay: '150ms' }} />
        <div className="w-2 h-2 rounded-full bg-primary animate-bounce" style={{ animationDelay: '300ms' }} />
      </div>
      <span className="text-secondary-text" style={{ fontSize: 'var(--text-caption)' }}>
        O Agente está a processar — pode demorar vários minutos
      </span>
    </div>
  );
}
